import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Mumbaioutstationcabs() {



  const cardData =
  {
    keyword: 'Mumbai Outstation Cabs  ',
    heading: 'Shambhu Cabs : Mumbai Outstation Cabs ',
    headingDescription: 'Shambhu Cabs offers convenient Mumbai Outstation Cabs, providing safe and comfortable travel for weekend getaways, pilgrimages, corporate trips, and family vacations from Mumbai to destinations across Maharashtra and beyond. Our fleet of hatchbacks, sedans, SUVs, and tempo travellers ensures a smooth and hassle-free journey, whether you’re heading to Lonavala, Mahabaleshwar, Shirdi, Goa, Nashik, or Kolhapur. With experienced chauffeurs, flexible one-way or round-trip options, and 24/7 booking assistance, Shambhu Cabs delivers reliable and affordable intercity travel. From South Mumbai to Thane, Andheri to Vashi, Shambhu Cabs provides doorstep pickup and trusted outstation cab services for individuals, families, and corporate travelers alike.',

    top: 'Top Places to Visit in Mumbai Outstation with Shambhu Cabs',

  "topPlaces": [
  {
    "title": "Lonavala & Khandala",
    "description": "Lonavala and Khandala — twin hill‑stations in the Western Ghats — are among Mumbai’s most popular quick escapes. With misty hills, lush greenery, waterfalls, caves and scenic viewpoints like Tiger’s Leap, they offer refreshing weather and an easy 2–3 hour drive from the city. Known for its famous chikki (local sweet), it’s a great combo of natural beauty and small‑town charm. Lonavala/Khandala is perfect for a relaxed weekend recharge away from city chaos."
  },
  {
    "title": "Alibaug",
    "description": "Alibaug — a coastal town less than 100 km from Mumbai — is ideal for a beachside retreat. With sandy beaches, coconut‑lined shores, historic forts and water‑sports (ferry + road accessible), it gives a ‘mini‑Goa’ feel without needing a flight. It’s a popular choice for families or groups looking for sun, sea and laid‑back vibes just a few hours from Mumbai."
  },
  {
    "title": "Matheran",
    "description": "Matheran — Asia’s only vehicle‑free hill station — offers a peaceful, pollution‑free escape ~80–100 km from Mumbai. With narrow paths, colonial‑era charm, toy‑train rides, panoramic viewpoints, and quiet mountain air, it’s a favourite for couples and nature lovers. The calmness and greenery make it an old‑school getaway away from the bustle."
  },
  {
    "title": "Karnala Bird Sanctuary & Fort",
    "description": "Karnala — about 60 km from Mumbai — combines a forested bird sanctuary (with 150+ bird species) and scenic hills with a historical fort. It’s a good pick for trekking, short‑distance nature getaways and easy drives. For those wanting a quick taste of greenery and tranquillity without travelling too far, Karnala is a solid choice."
  },
  {
    "title": "Kelva Beach / North‑Coast Beaches",
    "description": "Kelva Beach — around 80‑100 km from Mumbai — offers a quieter coastal escape to the north, away from typical southern beach crowds. With long stretches of sand and relatively peaceful surroundings, it appeals to those wanting sea, breeze and calm. Great for a laid‑back beach outing or a relaxed day‑trip from Mumbai."
  },
  {
    "title": "Tandulwadi Fort / Palghar Hills",
    "description": "Tandulwadi Fort — approx 100 km from Mumbai — offers a rustic, offbeat getaway into Palghar’s hill ranges. With rugged terrain, sweeping hill‑views and a chance to explore historical ruins, it’s suitable for trekking lovers or travellers looking for less‑crowded, off‑the‑beaten‑path escapes. A good option if you want a mix of hike, history and solitude not far from the city."
  },
  {
    "title": "Saguna Baug (Agro‑tourism Farm Near Neral)",
    "description": "Saguna Baug — a farm‑stay / agritourism spot near Neral — offers a different kind of weekend break: close to nature, river, farming experiences and slow living. Great for families or for those wanting a relaxed countryside vibe, away from touristy beaches or crowded hill stations. It’s ideal for a calm, rustic retreat without going too far from city limits."
  }
],


  "services": [
  {
    "name": "Mumbai Outstation Taxi Service",
    "description": "Mumbai Outstation Taxi Service offers reliable long-distance travel options from Mumbai to major cities and tourist destinations. With professional drivers and clean vehicles, it ensures a smooth and safe outstation journey."
  },
  {
    "name": "Outstation Cab Booking Mumbai",
    "description": "Outstation Cab Booking Mumbai provides an easy and seamless booking experience for travelers. Customers can select vehicle types, check availability, and confirm rides instantly for outstation routes."
  },
  {
    "name": "Mumbai Outstation Car Hire",
    "description": "Mumbai Outstation Car Hire offers flexible car rental options with trained chauffeurs for comfortable intercity travel. Suitable for families, groups, and corporate travelers."
  },
  {
    "name": "Mumbai to Pune Outstation Cab",
    "description": "Mumbai to Pune Outstation Cab delivers fast, safe, and convenient travel between Mumbai and Pune. Ideal for business trips, airport transfers, and leisure journeys."
  },
  {
    "name": "Mumbai to Goa Outstation Cab",
    "description": "Mumbai to Goa Outstation Cab provides dependable long-distance travel with comfortable vehicles and experienced drivers. Perfect for holiday trips, weekend travel, or one-way rides."
  },
  {
    "name": "Mumbai to Nashik Cab",
    "description": "Mumbai to Nashik Cab offers safe and comfortable transportation from Mumbai to Nashik, with timely pickups and well-maintained cabs for a smooth ride."
  },
  {
    "name": "Mumbai to Lonavala Outstation Cab",
    "description": "Mumbai to Lonavala Outstation Cab is ideal for weekend getaways, offering quick and comfortable travel with professional chauffeurs familiar with the route."
  },
  {
    "name": "Mumbai to Shirdi Cab",
    "description": "Mumbai to Shirdi Cab provides reliable and comfortable travel for pilgrims visiting Shirdi. The service ensures a peaceful journey with experienced drivers."
  },
  {
    "name": "Mumbai to Aurangabad Outstation Cab",
    "description": "Mumbai to Aurangabad Outstation Cab offers long-distance travel with flexible booking options, comfortable vehicles, and skilled drivers for seamless intercity journeys."
  },
  {
    "name": "Mumbai to Kolhapur Cab",
    "description": "Mumbai to Kolhapur Cab service provides convenient and safe travel from Mumbai to Kolhapur, suitable for business, family, or temple trips."
  },
  {
    "name": "Outstation Cab Mumbai",
    "description": "Outstation Cab Mumbai provides efficient outstation travel solutions with a variety of vehicles, ensuring a comfortable journey to destinations outside Mumbai."
  },
  {
    "name": "Outstation SUV Cab Mumbai",
    "description": "Outstation SUV Cab Mumbai offers spacious and comfortable SUVs for long-distance travel, ideal for families, groups, and mountain routes."
  },
  {
    "name": "Executive Outstation Cab Mumbai",
    "description": "Executive Outstation Cab Mumbai provides premium vehicles for corporate and luxury travel needs, ensuring a smooth and professional travel experience."
  },
  {
    "name": "One Way Outstation Cab Mumbai",
    "description": "One Way Outstation Cab Mumbai offers affordable one-direction travel to various cities, perfect for relocation, drop services, and planned trips."
  },
  {
    "name": "Affordable Outstation Taxi Mumbai",
    "description": "Affordable Outstation Taxi Mumbai delivers budget-friendly outstation cab options without compromising on safety or comfort, suitable for economical travelers."
  },
  {
    "name": "Corporate Outstation Cab Mumbai",
    "description": "Corporate Outstation Cab Mumbai specializes in premium intercity travel for business professionals, offering punctual service and high-quality vehicles."
  },
  {
    "name": "Mumbai Airport Outstation Cab",
    "description": "Mumbai Airport Outstation Cab provides convenient and reliable outstation transfers directly from the airport to major cities and towns with prompt pickup services."
  }
],

"tableData": [
  ["Mumbai Outstation Taxi Service", "Outstation Cab Booking Mumbai"],
  ["Mumbai Outstation Car Hire", "Mumbai to Pune Outstation Cab"],
  ["Mumbai to Goa Outstation Cab", "Mumbai to Nashik Cab"],
  ["Mumbai to Lonavala Outstation Cab", "Mumbai to Shirdi Cab"],
  ["Mumbai to Aurangabad Outstation Cab", "Mumbai to Kolhapur Cab"],
  ["Outstation Cab Mumbai", "Outstation SUV Cab Mumbai"],
  ["Executive Outstation Cab Mumbai", "One Way Outstation Cab Mumbai"],
  ["Affordable Outstation Taxi Mumbai", "Corporate Outstation Cab Mumbai"],
  ["Mumbai Airport Outstation Cab", "—"]
],

    "whychoose": [
  {
    "WhyChooseheading": "Mumbai Outstation Cabs with Shambhu Cabs",
    "WhyChoosedescription": "Shambhu Cabs provides reliable Mumbai Outstation Cabs, ideal for weekend trips, business travel, and long-distance journeys from Mumbai."
  },
  {
    "WhyChooseheading": "Comfortable and Well-Maintained Vehicles",
    "WhyChoosedescription": "Travel in clean, spacious, air-conditioned cabs that are regularly maintained to ensure a smooth and safe journey."
  },
  {
    "WhyChooseheading": "Experienced Drivers for Outstation Routes",
    "WhyChoosedescription": "Our skilled drivers are familiar with major outstation routes from Mumbai, ensuring a comfortable and timely travel experience."
  },
  {
    "WhyChooseheading": "Transparent and Affordable Pricing",
    "WhyChoosedescription": "Enjoy clear pricing with no hidden charges—fuel, tolls, and driver allowances are included for complete hassle-free travel."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Our dedicated support team is available 24/7 to assist you with bookings, inquiries, and route guidance."
  },
  {
    "WhyChooseheading": "Flexible Outstation Rental Plans",
    "WhyChoosedescription": "Choose from one-way, round-trip, or customized rental packages tailored to your Mumbai outstation travel needs."
  },
  {
    "WhyChooseheading": "Safe and Sanitized Cabs",
    "WhyChoosedescription": "Every vehicle is thoroughly cleaned and sanitized before each ride to ensure a safe and hygienic travel experience."
  },
  {
    "WhyChooseheading": "On-Time and Reliable Service",
    "WhyChoosedescription": "We ensure punctual pickups and dependable service, making your outstation journey from Mumbai stress-free and comfortable."
  }
]













  }

const faqData = [
  {
    question: 'Does Shambhu Cabs offer Mumbai outstation cab services?',
    answer: 'Yes, Shambhu Cabs provides reliable outstation cab services from Mumbai to various destinations across India.',
  },
  {
    question: 'How can I book Mumbai outstation cabs with Shambhu Cabs?',
    answer: 'You can easily book through our website, mobile app, or by contacting our 24x7 customer support team in Mumbai.',
  },
  {
    question: 'What types of vehicles are available for Mumbai outstation cab bookings?',
    answer: 'Shambhu Cabs offers a range of well-maintained sedans, SUVs, and luxury cars suitable for long-distance outstation travel from Mumbai.',
  },
  {
    question: 'Are drivers experienced and trained for Mumbai outstation cab bookings?',
    answer: 'Absolutely. Our drivers are licensed, punctual, and professionally trained to ensure a safe and comfortable journey.',
  },
  {
    question: 'Can pickup and drop-off locations be customized for Mumbai outstation bookings?',
    answer: 'Yes, you can specify preferred pickup and drop-off points within Mumbai and your chosen outstation destination.',
  },
  {
    question: 'Is the Mumbai outstation cab booking service available 24x7?',
    answer: 'Yes, Shambhu Cabs offers round-the-clock outstation cab booking services to suit your travel schedule.',
  },
  {
    question: 'Are safety and hygiene protocols followed for Mumbai outstation cab bookings?',
    answer: 'All vehicles are sanitized regularly, and drivers follow strict safety and hygiene guidelines for your well-being.',
  },
  {
    question: 'What payment options are accepted for Mumbai outstation cab bookings?',
    answer: 'We accept payments via corporate accounts, UPI, digital wallets, credit/debit cards, and bank transfers.',
  },
  {
    question: 'Is customer support available during the Mumbai outstation cab journey?',
    answer: 'Yes, our 24x7 customer support team is available to assist you throughout your outstation travel.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Arvind Sharma',
    feedback: 'Shambhu Cabs made our outstation trip from Mumbai smooth and stress-free. Excellent service!',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Riya Deshmukh',
    feedback: 'Very reliable and professional Mumbai outstation cab service by Shambhu Cabs. Highly recommended!',
    rating: 5,
  },
];








































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "mumbai-outstation-cabs" },
    { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "mumbai-to-mahabaleshwar-cab" },
    { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "mumbai-to-goa-cabs" },
    { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "mumbai-to-shirdi-cab" },
    { place: "/images/keyword/5.jpg", text: "Mumbai Nashik Cab", link: "mumbai-nashik-cab" },
    { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "mumbai-to-kolhapur-cab" },
    { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "mumbai-to-pune-cab" },
    { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "mumbai-to-aurangabad-cab" },
    { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "mumbai-to-bhimashankar-cab" },
    { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "mumbai-to-ashtavinayak-cab-service" },
    { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga Cab", link: "mumbai-to-5-jyotirlinga-cab" },
    { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "mumbai-to-lonavala-cab" },
    { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "mumbai-to-konkan-darshan-cab-booking" },
    { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "mumbai-to-alibaug-cab" },
    { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "mumbai-to-ahmednagar-cab" },
    { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran Cab", link: "mumbai-to-matheran-cab" },
    { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon / Dhule Cab", link: "mumbai-to-jalgaon-dhule-cab" },
    { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "mumbai-to-lavasa-cab" },
    { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "mumbai-to-panchgani-cab" },
    { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "mumbai-to-khandala-taxi-fare" },
    { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "mumbai-to-surat-cab" },
    { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "mumbai-to-ahmedabad-cab" },
    { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "mumbai-to-narmada-parikrama-cab-booking" },
    { place: "/images/keyword/24.jpg", text: "Mumbai to Vadodara Cab", link: "mumbai-to-vadodara-cab" },
    { place: "/images/keyword/25.jpg", text: "Mumbai to Daman Taxi", link: "mumbai-to-daman-taxi" },
  ];








const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai Outstation Cabs",
  "image": "https://www.shambhucab.com/assets/images/mumbai-outstation-cab.jpg",
  "description": "Shambhu Cabs offers reliable and comfortable Mumbai outstation cab services with well-maintained cars and professional drivers. Book outstation taxis from Mumbai to Pune, Goa, Nashik, Lonavala, Shirdi, Aurangabad, Kolhapur and more at affordable prices. Choose from sedans, SUVs, and premium cars for one-way or round-trip travel.",
  "brand": {
    "@type": "Brand",
    "name": "Shambhu Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "ratingCount": "5300",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "10",
    "availability": "https://schema.org/InStock",
    "url": "https://www.shambhucab.com/mumbai-outstation-cabs"
  }
};





  return (
    <div>
<Helmet>
  <title>Mumbai Outstation Cabs | Affordable Outstation Taxi Service | Shambhu Cabs</title>

  <meta
    name="description"
    content="Book Mumbai outstation cabs with Shambhu Cabs for safe, comfortable, and affordable long-distance travel. Outstation taxi booking from Mumbai to Pune, Goa, Nashik, Shirdi, Lonavala, Aurangabad, Kolhapur and more. Choose one-way or round-trip outstation cabs."
  />

  <meta
    name="keywords"
    content="Mumbai Outstation Taxi Service, Outstation Cab Booking Mumbai, Mumbai Outstation Car Hire, Mumbai to Pune Outstation Cab, Mumbai to Goa Outstation Cab, Mumbai to Nashik Cab, Mumbai to Lonavala Outstation Cab, Mumbai to Shirdi Cab, Mumbai to Aurangabad Outstation Cab, Mumbai to Kolhapur Cab, Outstation Cab Mumbai, Outstation SUV Cab Mumbai, Executive Outstation Cab Mumbai, One Way Outstation Cab Mumbai, Affordable Outstation Taxi Mumbai, Corporate Outstation Cab Mumbai, Mumbai Airport Outstation Cab"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
      <section className="gauto-breadcromb-area section_70">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="breadcromb-box">
                <h3> {cardData.keyword}</h3>
              </div>
            </div>
          </div>
        </div>
      </section>







      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/74.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

            

              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Shambhu Cabs</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Shambhu Cabs </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919819399797" className="pc-call">+91 9819399797</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919819399797"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919819399797" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@shambhucab.com" className="pc-email">
                      booking@shambhucab.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Shambhu Cabs</strong><br />
                      Saket Tata Power CHS, Swami Samarth Marg,
                      Juhu Nagar, Sector-16, Vashi, Navi Mumbai,
                      Maharashtra India - 400703
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Mumbaioutstationcabs;